import { render, staticRenderFns } from "./ProductSignChange.vue?vue&type=template&id=f6fbd5a0&scoped=true&"
import script from "./ProductSignChange.vue?vue&type=script&lang=js&"
export * from "./ProductSignChange.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6fbd5a0",
  null
  
)

export default component.exports